// extracted by mini-css-extract-plugin
module.exports = {"heading":"Header_heading__sAf1D","light":"Header_light__1p9Mt"};